import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      scrollToTop: true
    },
    component: Home
  },
  {
    path: '/empresa',
    name: 'Enterprise',
    meta: {
      scrollToTop: true
    },
    // route level code-splitting
    // this generates a separate chunk (enterprise.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "enterprise" */ '../views/Enterprise.vue')
  },
  {
    path: '/planos',
    name: 'Plans',
    meta: {
      scrollToTop: true
    },
    component: () =>
      import(/* webpackChunkName: "plans" */ '../views/Plans.vue')
  },
  {
    path: '/contato',
    name: 'Contact',
    meta: {
      scrollToTop: true
    },
    component: () =>
      import(/* webpackChunkName: "plans" */ '../views/Contact.vue')
  }
]

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {
      behavior: 'smooth'
    }

    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash

      // specify offset of the element
      if (to.hash === '#selectInst') {
        position.offset = {
          y: store?.state?.page?.alert?.model ? 72 : 0
        }
      }

      return position

      // // bypass #1number check
      // if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
      //   return position
      // }

      // // if the returned position is falsy or an empty object,
      // // will retain current scroll position.
      // return false
    }

    return new Promise((resolve) => {
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some((m) => m.meta.scrollToTop)) {
        // coords will be used if no selector is provided,
        // or if the selector didn't match any element.
        position.x = 0
        position.y = 0
      }

      // wait for the out transition to complete (if necessary)
      // this.app.$root.$once("triggerScroll", () => {
      //   // if the resolved position is falsy or an empty object,
      //   // will retain current scroll position.
      //   resolve(position)
      // })
      resolve(position)
    })
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes
})

export default router
